<template>
  <div>
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams1">
        <!-- 竞品品牌1 -->
        <el-form-item label="竞品品牌1">
          <el-select
            filterable
            v-model="queryParams1.brandOne"
            placeholder="请选择"
            clearable
            @change="changeBrand('One')"
          >
            <el-option
              v-for="(item, index) in competeBrandList"
              :key="index"
              :label="item"
              :value="item"
              :disabled="
                queryParams1.brandTwo === item ||
                  queryParams1.brandThree === item
              "
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 竞品品牌2 -->
        <el-form-item label="竞品品牌2">
          <el-select
            filterable
            v-model="queryParams1.brandTwo"
            placeholder="请选择"
            clearable
            @change="changeBrand('Two')"
          >
            <el-option
              v-for="(item, index) in competeBrandList"
              :key="index"
              :label="item"
              :value="item"
              :disabled="
                queryParams1.brandOne === item ||
                  queryParams1.brandThree === item
              "
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 竞品品牌3 -->
        <el-form-item label="竞品品牌3">
          <el-select
            filterable
            v-model="queryParams1.brandThree"
            placeholder="请选择"
            clearable
            @change="changeBrand('Three')"
          >
            <el-option
              v-for="(item, index) in competeBrandList"
              :key="index"
              :label="item"
              :value="item"
              :disabled="
                queryParams1.brandOne === item || queryParams1.brandTwo === item
              "
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 操作 -->
        <el-form-item label=" ">
          <el-button
            type="primary"
            size="small"
            @click="getCompeteBrandStatis()"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <chart
      ref="competeBrandSale"
      :height="300"
      :option="competeBrandSaleOption()"
    />
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams1">
        <!-- 车型1 -->
        <el-form-item label="车型1">
          <el-select
            filterable
            v-model="queryParams2.carModelOne"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(item, index) in carModelListOne"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 车型2 -->
        <el-form-item label="车型2">
          <el-select
            filterable
            v-model="queryParams2.carModelTwo"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(item, index) in carModelListTwo"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 车型3 -->
        <el-form-item label="车型3">
          <el-select
            filterable
            v-model="queryParams2.carModelThree"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(item, index) in carModelListThree"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 操作 -->
        <el-form-item label=" ">
          <el-button type="primary" size="small" @click="getCarModelStatis()"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <chart ref="carModelSale" :height="300" :option="carModelSaleOption()" />
    <chart ref="carModelPrice" :height="300" :option="carModelPriceOption()" />
  </div>
</template>
<script>
import Chart from "@/components/chart";
import {
  getCompeteBrandListApi,
  getCarModelListApi,
  getBrandSaleStatisApi,
  getCarModelSalePriceStatisApi
} from "@/api/saleTaskCollection";
// （柱状 | 折现）图
function getBarOrLineChartOption(config = {}) {
  return {
    title: {
      text: config.title,
      top: 10,
      left: 50,
      textStyle: {
        fontSize: 16
      }
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    legend: {
      show: config.legend,
      data: config.legend,
      bottom: 5
    },
    grid: config.grid,
    xAxis: {
      type: config.xAxisType,
      axisLabel: {
        formatter: config.formatter
      },
      data: config.xAxis
    },
    yAxis: {
      type: config.yAxisType,
      axisLabel: {
        formatter: config.formatter
      },
      data: config.yAxis
    },
    series: config.series
  };
}

export default {
  name: "competeBrand",
  components: {
    Chart
  },
  data() {
    return {
      queryParams: {},
      queryParams1: {},
      queryParams2: {},
      competeBrandList: [], // 竞品品牌列表
      carModelListOne: [], // 车型列表1
      carModelListTwo: [], // 车型列表2
      carModelListThree: [], // 车型列表3
      competeBrandSaleStatis: [],
      carModelSaleStatis: [],
      carModelPriceStatis: [],
      color1: [
        "#A0522D",
        "#FF0000",
        "#FF6600",
        "#FF9900",
        "#FFCC00",
        "#FFFF00",
        "#CCFF00",
        "#99FF00",
        "#66FF00",
        "#33FF00",
        "#00FF00",
        "#00FF33",
        "#00FF66",
        "#00FF7F",
        "#00FFCC"
      ],
      color2: [
        "#00FFFF",
        "#00CCFF",
        "#0099FF",
        "#0066FF",
        "#0033FF",
        "#3300FF",
        "#6600FF",
        "#9900FF",
        "#CC00FF",
        "#FF00FF",
        "#FF00CC",
        "#FF0099",
        "#FF0066",
        "#FF0033",
        "#C0C0C0"
      ]
    };
  },
  methods: {
    // 获取竞品品牌列表
    async getCompeteBrandList() {
      const res = await getCompeteBrandListApi(this.queryParams);
      this.competeBrandList = res.data || [];
    },
    // 获取车型列表
    async getCarModelList(index) {
      const res = await getCarModelListApi({
        ...this.queryParams,
        brand: this.queryParams1[`brand${index}`]
      });
      this[`carModelList${index}`] = res.data || [];
    },
    // 初始化
    async init(queryParams) {
      this.queryParams = queryParams;
      await this.getCompeteBrandList();
      this.queryParams1 = {
        brandOne: "",
        brandTwo: "",
        brandThree: ""
      };
      this.carModelListOne = [];
      this.carModelListTwo = [];
      this.carModelListThree = [];
      this.queryParams2 = {
        carModelOne: "",
        carModelTwo: "",
        carModelThree: ""
      };

      this.getCompeteBrandStatis();
      this.getCarModelStatis();
    },
    // 切换品牌
    changeBrand(index) {
      this.queryParams2[`carModel${index}`] = "";
      this.getCarModelList(index);
      this.getCarModelStatis();
    },
    //  获取竞品品牌统计
    async getCompeteBrandStatis() {
      this.$refs.competeBrandSale?.myChart.showLoading();
      try {
        const res = await getBrandSaleStatisApi({
          ...this.queryParams,
          brandOne: this.queryParams1.brandOne,
          brandTwo: this.queryParams1.brandTwo,
          brandThree: this.queryParams1.brandThree
        });
        this.competeBrandSaleStatis = res.data || [];
      } catch (error) {}
      this.$refs.competeBrandSale?.myChart.hideLoading();
    },
    // 获取车型统计
    async getCarModelStatis() {
      this.$refs.carModelSale?.myChart.showLoading();
      this.$refs.carModelPrice?.myChart.showLoading();
      try {
        const res = await getCarModelSalePriceStatisApi({
          ...this.queryParams,
          carModelOne: this.queryParams2.carModelOne,
          carModelTwo: this.queryParams2.carModelTwo,
          carModelThree: this.queryParams2.carModelThree
        });
        this.carModelSaleStatis = res.data.competitionCarModelSaleList || [];
        this.carModelPriceStatis = res.data.competitionCarModelPriceList || [];
      } catch (error) {}
      this.$refs.carModelSale?.myChart.hideLoading();
      this.$refs.carModelPrice?.myChart.hideLoading();
    },
    // 竞品销量
    competeBrandSaleOption() {
      let legend = [];
      let series = [];
      this.competeBrandSaleStatis.map(item => {
        legend.push(item.name);
        series.push({
          name: item.name,
          type: "line",
          data: item.data,
          barCategoryGap: "50%", // 类目间隔
          barGap: "0", // 系列间隔
          label: {
            show: true,
            position: "top"
          }
        });
      });
      const config = {
        legend: legend,
        title: "销量",
        grid: { bottom: 80, top: 60, left: 120, right: 120 },
        xAxisType: "category",
        yAxisType: "value",
        xAxis: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ],
        series: series
      };
      return getBarOrLineChartOption(config);
    },
    // 车型销量
    carModelSaleOption() {
      let legend = [];
      let series = [];
      this.carModelSaleStatis.map((item, index) => {
        legend.push(item.name);
        series.push({
          name: item.name,
          type: "line",
          color: this.color1[index],
          data: item.data,
          barCategoryGap: "50%", // 类目间隔
          barGap: "0", // 系列间隔
          label: {
            show: true,
            position: "top"
          }
        });
      });
      const config = {
        legend: legend,
        title: "销量",
        grid: { bottom: 80, top: 60, left: 120, right: 120 },
        xAxisType: "category",
        yAxisType: "value",
        xAxis: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ],
        series: series
      };
      return getBarOrLineChartOption(config);
    },
    // 车型价格
    carModelPriceOption() {
      let legend = [];
      let series = [];
      this.carModelPriceStatis.map((item, index) => {
        legend.push(item.name);
        const carModelIndex = this.carModelSaleStatis.findIndex(
          item2 => item2.name === item.name
        );
        series.push({
          name: item.name,
          type: "line",
          color:
            carModelIndex === -1
              ? this.color2[index]
              : this.color1[carModelIndex],
          data: item.data,
          barCategoryGap: "50%", // 类目间隔
          barGap: "0", // 系列间隔
          label: {
            show: true,
            position: "top"
          }
        });
      });
      const config = {
        legend: legend,
        title: "价格",
        grid: { bottom: 80, top: 60, left: 120, right: 120 },
        xAxisType: "category",
        yAxisType: "value",
        xAxis: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ],
        series: series
      };
      return getBarOrLineChartOption(config);
    }
  }
};
</script>

<style scoped lang="scss">
.filter-container {
  padding: 30px 20px 0 20px;
  border-bottom: 5px solid #efefef;
  ::v-deep .el-input {
    width: 150px;
  }
}
</style>
